import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';
import { ChatTeamAdmin, ChatTeamMemberAdmin } from '../models/chat-team-admin.model';

interface ChatTeamDrawerOptions {
  id?: number;
  /** Sub-recurso: id del equipo al que pertenece el miembro. */
  parentId?: number;
}

/** Misma convención que los drawers de configuración de Tickets. */
class BaseChatTeamDrawerService<T> {
  private readonly registry = inject(DrawerRegistryService);
  protected readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: ChatTeamDrawerOptions }>({
    isOpen: false,
    options: {}
  });
  protected readonly saved$$ = new Subject<T>();

  readonly state = this.state$.asObservable();

  open(options: ChatTeamDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(entity: T): void {
    this.saved$$.next(entity);
  }
}

@Injectable({ providedIn: 'root' })
export class ChatTeamDrawerService extends BaseChatTeamDrawerService<ChatTeamAdmin> {
  readonly entitySaved$ = this.saved$$.asObservable();
}

@Injectable({ providedIn: 'root' })
export class ChatTeamMemberDrawerService extends BaseChatTeamDrawerService<ChatTeamMemberAdmin> {
  readonly entitySaved$ = this.saved$$.asObservable();
}
